import React, { ComponentType, useState } from 'react';

import { IconButton } from '@material-ui/core';
import { KeyboardArrowDown as KeyboardArrowDownIcon, KeyboardArrowUp as KeyboardArrowUpIcon } from '@material-ui/icons';
import PropTypes from 'prop-types';

export interface WithExpandProps {
  initialExpand?: boolean;
}

export interface ComponentWithExpandProps {
  expanded: boolean;
  renderExpand: () => JSX.Element;
  handleToggleExpand: () => void;
}

export const withExpand =
  <T,>(Component: ComponentType<T & ComponentWithExpandProps>) =>
  ({ initialExpand, ...props }: WithExpandProps): JSX.Element => {
    const [expanded, setExpanded] = useState<boolean>(initialExpand ?? false);

    const handleToggleExpand = (): void => setExpanded(prev => !prev);

    const renderExpand = (): JSX.Element => (
      <IconButton size="small" color="primary">
        {expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      </IconButton>
    );

    return (
      <Component
        {...(props as T)}
        expanded={expanded}
        renderExpand={renderExpand}
        handleToggleExpand={handleToggleExpand}
      />
    );
  };

export const withExpandPropTypes = {
  expanded: PropTypes.bool.isRequired,
  renderExpand: PropTypes.func.isRequired,
  handleToggleExpand: PropTypes.func.isRequired,
};
